import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Layout, Button } from 'antd';

import Images from '../Images';
import OnBoardingCreators from "./Onboarding/reducer";

function CheckoutSuccessPage(props) {
  const { isMobile, setCompletelyFinishedOnboarding, completelyFinishedOnboarding } = props;

  let history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'Success - In_Home';
    if (completelyFinishedOnboarding) history.push('/dashboard');
  }, []);

  function handleNavigate() {
    setCompletelyFinishedOnboarding();
    history.push('/dashboard');
  }

  return (
    <Layout>
      <div className="login-row">
        <div className="login-content success checkout">

          <div className="page-content">

            <div className={`content-title`}>
              <h2>{t('Welcome to In_Home')}</h2>
              <div>{t('You now have access to In_Home')}</div>
            </div>

            <img src={isMobile ? Images.checkoutSuccessMobile : Images.checkoutSuccess} alt=""/>

            <Button type="primary" className="btn-primary" onClick={handleNavigate}>
              {t('Go To Dashboard')}
            </Button>
          </div>
        </div>

      </div>
    </Layout>
  );
}

const mapStateToProps = (state) => {
  return {
    isMobile: state.nav.isMobile,
    completelyFinishedOnboarding: state.onBoarding.completelyFinishedOnboarding,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setCompletelyFinishedOnboarding: () => dispatch(OnBoardingCreators.setCompletelyFinishedOnboarding()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSuccessPage);
